import { withAuthenticationRequired } from '@tom-ui/utils'
import { useGeneralCargoOrderLocations } from '@host/hooks/useGeneralCargoOrderLocations'
import { GeneralCargoOrderFormPage, GeneralCargoPage } from '@tom-ui/planning'
import {
  GeneralCargoDamage,
  GeneralCargoOrderReservationDialog,
  OutboundRequestValidationControl,
  generalCargoDamageService,
  useStorageStore,
} from '@tom-ui/storage'
import { OrderResponseDto } from 'modules/planning/src/app/api'
import { OutboundOrderValidationDto } from 'modules/planning/src/stores/gateControl/ValidateOutboundDto'
import { useCallback } from 'react'
import { OrderDamageDto } from './DamageOrderDto'

const useGeneralCargoOrderFormDependencies = () => {
  const renderDamage = (orderId: number) => <GeneralCargoDamage orderId={orderId} />

  const validateOutboundRequest = (params: OutboundOrderValidationDto): React.ReactElement => (
    <OutboundRequestValidationControl
      isOutbound={params.isOutbound}
      customerId={params.customerId}
      commodityId={params.commodityId}
      lotNumber={params.lotNumber}
      packageId={params.packageId}
      quantity={params.quantity}
      unitIds={params.unitIds}
      imoClasses={params.imoClasses}
    />
  )

  return { renderDamage, validateOutboundRequest }
}

export const GeneralCargoOrderFormRoutePage = withAuthenticationRequired(() => {
  const { renderDamage, validateOutboundRequest } = useGeneralCargoOrderFormDependencies()

  return (
    <GeneralCargoOrderFormPage
      renderDamage={renderDamage}
      validateOutboundRequest={validateOutboundRequest}
    />
  )
})

export const GeneralCargoOrdersPage = withAuthenticationRequired(() => {
  const { tenantConfigStore, generalCargoOrderReservationUIStore } = useStorageStore()

  const { reservationUpdate, handleGetOrderLocations, handleGetOrderReservations } =
    useGeneralCargoOrderLocations()

  const handleGetOrdersDamageAmount = useCallback(async (orderIds: number[]) => {
    const damages = await generalCargoDamageService.getOrderDamageAmount(orderIds)

    return damages.map(
      (x: any) =>
        ({
          orderId: x.orderId,
          amount: x.totalQuantity,
        }) as OrderDamageDto,
    )
  }, [])

  const handleOpenReservation = (order: OrderResponseDto) => {
    generalCargoOrderReservationUIStore.toggleDialog(
      order.id,
      undefined,
      order.plannedCargoAmount ?? 0,
      order.direction,
    )
  }

  return (
    <>
      <GeneralCargoPage
        onOpenReservation={tenantConfigStore.skipYardPlanning ? undefined : handleOpenReservation}
        getOrderDamagesAmountFunc={handleGetOrdersDamageAmount}
        getOrderLocationsFunc={handleGetOrderLocations}
        getOrderReservationsFunc={handleGetOrderReservations}
        reservationUpdate={reservationUpdate ?? undefined}
      />
      <GeneralCargoOrderReservationDialog />
    </>
  )
})
